import React, { useEffect, useRef, useState } from "react";
import { FallingLines } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ReactComponent as EmojiBtnIcon } from "../../assets/icons/EmojiBtnIcon.svg";
import HeartFilled from "../../assets/svg/HeartFilled.svg";
import HeartUnfilled from "../../assets/svg/HeartUnfilled.svg";
import comment from "../../assets/svg/comment.svg";
import share from "../../assets/svg/share.svg";
import { setShareData } from "../../redux/slices/tempSlice";
import Header from "../Header/Header";
import ScrollToTop from "../Hooks/ScrollToTop";
import axios from "../Hooks/axios";
import styles from "./ViewStory.module.scss";
import EmojiPicker from "emoji-picker-react";
import { CiSettings } from "react-icons/ci";
import { BiSolidPencil } from "react-icons/bi";
import { RxCross2 } from "react-icons/rx";
import { GoArrowLeft } from "react-icons/go";
import { ReactComponent as ReportIcon } from "../../assets/icons/ReportIcon.svg";
import { ReactComponent as BlockUserIcon } from "../../assets/icons/BlockUserIcon.svg";
import { ReactComponent as RemoveMention } from "../../assets/icons/RemoveMention.svg";
import { ReactComponent as UnfollowIcon } from "../../assets/icons/UnfollowIcon.svg";
import { ReactComponent as SaveIcon } from "../../assets/icons/SaveIcon.svg";
import { ReactComponent as HidePostIcon } from "../../assets/icons/HidePostIcon.svg";
import DefaultProfilePic from "../../assets/images/user.png";

const resolveMediaUrl = (mediaUrl) => {
	if (!mediaUrl) return "";
	if (Array.isArray(mediaUrl)) {
		if (mediaUrl.length === 0) return "";
		const first = mediaUrl[0];
		return typeof first === "string" ? first : first?.url || "";
	}
	if (typeof mediaUrl === "object") {
		return mediaUrl?.url || "";
	}
	return mediaUrl;
};

const CommentBox = ({ data, userId, commentId, setCommentId, handleLikeComment }) => {
	const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
	return (
		<div className={styles.CommentBox}>
			<div className={styles.CBLeft}>
				<div className={styles.ImageWrapper}>
					<img
						src={data?.userId?.ProfilePic || DefaultProfilePic}
						onError={(e) => { e.target.src = DefaultProfilePic; }}
						alt=""
					/>
				</div>

				<div className={styles.TextWrapper}>
					<div className={styles.Name}>{data?.userId?.username}</div>
					<div className={styles.Text}>{data.text}</div>
					<div className={styles.ButtonContainer}>
						<button onClick={() => handleLikeComment(data._id)}>
							{data.likes?.length || 0}+ like
						</button>
						<button
							style={{
								background: data._id === commentId ? "#A6539D" : "",
								color: data._id === commentId ? "#fff" : "",
							}}
							onClick={() => {
								if (data?._id === commentId) {
									setCommentId("");
								} else {
									setCommentId(data._id);
								}
							}}>
							Reply
						</button>
						<button onClick={() => handleLikeComment(data._id)}>{isLiked ? "Unlike" : "Like"}</button>
						<span className={styles.Timestamp}>
							{new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} on {new Date(data.timestamp || Date.now()).toLocaleDateString([], { month: '2-digit', day: '2-digit', year: '2-digit' })}
						</span>
					</div>
				</div>
			</div>

			<div className={styles.CBRight}>
				<div onClick={() => handleLikeComment(data._id)} style={{ cursor: 'pointer' }}>
					<img
						src={isLiked ? HeartFilled : HeartUnfilled}
						alt="heart"
						style={{ width: '1.8rem', height: '1.8rem' }}
					/>
				</div>
			</div>
		</div>
	);
};

const SubCommentBox = ({ data, parentId, userId, commentId, setCommentId, handleLikeComment }) => {
	const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
	return (
		<div className={styles.SubCommentBox}>
			<div className={styles.CBLeft}>
				<div className={styles.ImageWrapper}>
					<img
						src={data?.userId?.ProfilePic || DefaultProfilePic}
						onError={(e) => { e.target.src = DefaultProfilePic; }}
						alt=""
					/>
				</div>

				<div className={styles.TextWrapper}>
					<div className={styles.Name}>{data?.userId?.username}</div>
					<div className={styles.Text}>{data.text}</div>
					<div className={styles.ButtonContainer}>
						<button onClick={() => handleLikeComment(parentId, data._id)}>
							{data.likes?.length || 0}+ like
						</button>
						<button
							style={{
								background: data._id === commentId ? "#A6539D" : "",
								color: data._id === commentId ? "#fff" : "",
							}}
							onClick={() => {
								if (data?._id === commentId) {
									setCommentId("");
								} else {
									setCommentId(data._id);
								}
							}}>
							Reply
						</button>
						<button onClick={() => handleLikeComment(parentId, data._id)}>{isLiked ? "Unlike" : "Like"}</button>
						<span className={styles.Timestamp}>
							{new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} on {new Date(data.timestamp || Date.now()).toLocaleDateString([], { month: '2-digit', day: '2-digit', year: '2-digit' })}
						</span>
					</div>
				</div>
			</div>

			<div className={styles.CBRight}>
				<div onClick={() => handleLikeComment(parentId, data._id)} style={{ cursor: 'pointer' }}>
					<img
						src={isLiked ? HeartFilled : HeartUnfilled}
						alt="heart"
						style={{ width: '1.8rem', height: '1.8rem' }}
					/>
				</div>
			</div>
		</div>
	);
};

const ThirdLayerBox = ({ data, storyId, parentId, userId, handleLikeComment }) => {
	const isLiked = data.likes?.some(id => (id._id || id).toString() === userId?.toString());
	return (
		<div className={styles.ThirdLayerBox}>
			<div className={styles.CBLeft}>
				<div className={styles.ImageWrapper}>
					<img
						src={data?.userId?.ProfilePic || DefaultProfilePic}
						onError={(e) => { e.target.src = DefaultProfilePic; }}
						alt=""
					/>
				</div>
				<div className={styles.TextWrapper}>
					<div className={styles.Name}>{data?.userId?.username}</div>
					<div className={styles.Text}>{data.text}</div>
					<div className={styles.ButtonContainer}>
						<button onClick={() => handleLikeComment(storyId, parentId, data._id)}>
							{data.likes?.length || 0}+ like
						</button>
						<button onClick={() => handleLikeComment(storyId, parentId, data._id)}>{isLiked ? "Unlike" : "Like"}</button>
						<span className={styles.Timestamp}>
							{new Date(data.timestamp || Date.now()).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} on {new Date(data.timestamp || Date.now()).toLocaleDateString([], { month: '2-digit', day: '2-digit', year: '2-digit' })}
						</span>
					</div>
				</div>
			</div>
			<div className={styles.CBRight}>
				<div onClick={() => handleLikeComment(storyId, parentId, data._id)} style={{ cursor: 'pointer' }}>
					<img
						src={isLiked ? HeartFilled : HeartUnfilled}
						alt="heart"
						style={{ width: '1.5rem', height: '1.5rem' }}
					/>
				</div>
			</div>
		</div>
	);
};

const ViewStory = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { id } = useParams();
	const { userId } = useSelector((state) => state.auth);
	const { state } = useLocation();
	const [showComments, setShowComments] = useState(false);

	const [commentsData, setCommentsData] = useState([]);
	const [commentId, setCommentId] = useState("");
	const [commentText, setCommentText] = useState("");

	const [isLiked, setIsLiked] = useState(false);
	const [likeCount, setLikeCount] = useState(0);
	const inputRef = useRef();
	const [threeDotShow, setThreeDotShow] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	//Story
	const [storyUserData, setStoryUserData] = useState(null);
	const [storyData, setStoryData] = useState([]);
	const [activeIndex, setActiveIndex] = useState(0);
	const [isClicked, setIsClicked] = useState(true);
	const [last, setLast] = useState(false);

	// User Related
	const [activeUserId, setActiveUserId] = useState(id);
	const [userBtn, setUserBtn] = useState({ in: -1, ml: 0 });
	const [allStoryUser, setAllStoryUser] = useState([]);

	const [openEmoji, setOpenEmoji] = useState(false);

	// Social Feature States
	const { user } = useSelector((state) => state.auth);
	const [showReportModal, setShowReportModal] = useState(false);
	const [showBlockModal, setShowBlockModal] = useState(false);
	const [reportReason, setReportReason] = useState("");
	const [isFollowing, setIsFollowing] = useState(false);
	const [sortOrder, setSortOrder] = useState("latest");
	const [showSortDropdown, setShowSortDropdown] = useState(false);

	useEffect(() => {
		if (userBtn.in === -1) setActiveUserId(id);
	}, [userBtn.in]);

	useEffect(() => {
		axios
			.get("/story/stories")
			.then(({ data }) => {
				const filterData = data.filter((item) => {
					if (item.userId._id !== id) return true;
				});
				setAllStoryUser(filterData);
			})
			.catch(({ response }) => {
				console.log(response);
			});
	}, []);

	useEffect(() => {
		setLast(false);
		setActiveIndex(0);
		setIsClicked(true);

		setIsLoading(true);
		axios
			.get(`/story/mystory/${activeUserId}`)
			.then(({ data }) => {
				setStoryUserData(data.data?.userId);
				setStoryData(data.data?.stories);
				setIsLoading(false);
			})
			.catch((e) => {
				console.log(e);
			});
	}, [activeUserId]);

	useEffect(() => {
		setIsLoading(true);
		if (storyData.length > 0) {
			setCommentsData(storyData[activeIndex]?.Comments);
			setLikeCount(storyData[activeIndex]?.LikeCount);
			setIsLiked(storyData[activeIndex]?.isLike);

			// Initial following status
			if (user?.followingData && storyUserData) {
				setIsFollowing(user.followingData.includes(storyUserData._id));
			}
		}
		setIsLoading(false);
	}, [activeIndex, storyData, storyUserData, user]);

	const isWatchAll = state?.watchAll || false;

	useEffect(() => {
		if (storyData.length === 0) return;

		if (isClicked && !threeDotShow && !showReportModal && !showBlockModal) {
			const si = setInterval(() => {
				if (activeIndex < storyData.length - 1) {
					setActiveIndex((prev) => prev + 1);
					setLast(false);
				} else {
					// Current user's stories finished
					if (isWatchAll && allStoryUser.length > 0) {
						// Move to next user
						const nextUser = allStoryUser[0];
						setActiveUserId(nextUser.userId._id);
						// Update allStoryUser list for the next iteration
						const remainingUsers = allStoryUser.slice(1);
						setAllStoryUser(remainingUsers);
						setActiveIndex(0);
						setLast(false);
					} else {
						// No more users or not in Watch All mode
						setLast(true);
					}
					clearInterval(si);
				}
			}, 5000);

			return () => clearInterval(si);
		}
	}, [storyData, activeIndex, isClicked, isWatchAll, allStoryUser, threeDotShow, showReportModal, showBlockModal]);

	const fetchComments = () => {
		axios
			.get(`/story/get-comments/${storyData[activeIndex]?._id}`)
			.then(({ data }) => {
				setCommentsData(data.comments);
				setIsClicked(true);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const postComment = () => {
		if (commentText === "") return toast.warn("Please write something !");
		const id = toast.loading("Comment Posting...");
		axios
			.post(`story/comment/${storyData[activeIndex]?._id}`, {
				userId,
				text: commentText,
			})
			.then(({ data }) => {
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				setCommentsData(data.stories.Comments);
				setCommentText("");
				setIsClicked(true);
			})
			.catch((e) => {
				console.log(e);
			});
	};

	const postCommentOnComment = () => {
		if (commentText === "") return toast.warn("Please write something !");
		const id = toast.loading("Comment Posting...");
		axios
			.post(`story/comment?storyId=${storyData[activeIndex]?._id}&commentId=${commentId}&userId=${userId}`, {
				text: commentText,
			})
			.then(({ data }) => {
				toast.update(id, {
					render: data.message,
					type: "success",
					isLoading: false,
					autoClose: 2000,
				});
				setCommentText("");
				fetchComments();
				setCommentId("");
				inputRef?.current?.blur();
			})
			.catch(({ response: { data } }) => {
				toast.update(id, {
					render: data.message,
					type: "error",
					isLoading: false,
					autoClose: 2000,
				});
			});
	};

	const handleLikeComment = (commentId, replyId = null, subReplyId = null) => {
		if (!userId) return toast.info("Please login to like comments");

		let targetCommentId = commentId;
		if (subReplyId) targetCommentId = subReplyId;
		else if (replyId) targetCommentId = replyId;

		axios.post(`story/like-comment`, {
			storyId: storyData[activeIndex]?._id,
			commentId: targetCommentId,
			userId
		}).then(({ data }) => {
			fetchComments();
		}).catch(err => {
			console.log(err);
			if (err.response?.data?.message) {
				toast.error(err.response.data.message);
			}
		});
	};

	const getReplyingToUsername = (id) => {
		if (!id || !commentsData) return null;
		const findInArray = (arr) => {
			for (const c of arr) {
				if (c._id === id) return c.userId?.username;
				if (c.Comments) {
					const found = findInArray(c.Comments);
					if (found) return found;
				}
			}
			return null;
		};
		return findInArray(commentsData);
	};

	const getSortedComments = () => {
		if (!commentsData) return [];
		let sorted = [...commentsData];
		if (sortOrder === "latest") {
			sorted.sort((a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0));
		} else {
			sorted.sort((a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0));
		}
		return sorted;
	};

	const handelLike = () => {
		axios
			.post(`story/${storyData[activeIndex]?._id}/like`, {
				userId,
			})
			.then(({ data }) => {
				if (data.message === "story liked successfully") setIsLiked(true);
				if (data.message === "story unliked successfully") setIsLiked(false);
				setLikeCount(data.totalLikes);
			})
			.catch(({ response }) => {
				console.log(response);
			});
	};

	const handleBlock = async (targetUserId) => {
		if (!userId) return toast.info("Please login to block users");
		try {
			const { data } = await axios.post("/auth/block-unblock-user", {
				user_id: targetUserId,
				type: "block",
			});
			toast.success(data.message);
			setThreeDotShow(false);
			setShowBlockModal(false);
		} catch (error) {
			toast.error(error.response?.data?.message || "Failed to block user");
		}
	};

	const handleReport = async (targetUserId) => {
		if (!userId) return toast.info("Please login to report users");
		if (!reportReason.trim()) return toast.warn("Please provide a reason");

		try {
			await axios.post("/auth/report-user", {
				reported_user_id: targetUserId,
				reason: reportReason,
			});
			toast.success("User reported successfully");
			setReportReason("");
			setShowReportModal(false);

			setTimeout(() => {
				setShowBlockModal(true);
			}, 500);
		} catch (error) {
			toast.error(error.response?.data?.message || "Failed to report user");
		}
	};

	const handleFollow = async (targetUserId) => {
		if (!userId) return toast.info("Please login to follow users");
		try {
			const { data } = await axios.post("/auth/follow", {
				following: targetUserId,
			});
			toast.success(data.message);
			setIsFollowing(data.message === "follow");
			setThreeDotShow(false);
		} catch (error) {
			toast.error(error.response?.data?.message || "Action failed");
		}
	};

	useEffect(() => {
		if (commentId !== "") inputRef?.current?.focus();
		if (commentId === "") inputRef?.current?.blur();
	}, [commentId]);

	let clickTimer;

	const handelMouseDown = () => {
		clickTimer = setTimeout(() => {
			setIsClicked(false);
		}, 800);
	};

	const handleMouseUp = () => {
		clearTimeout(clickTimer);
		setIsClicked(true);
	};

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 1024);
		};

		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	useEffect(() => {
		if (last) navigate("/Home");
	}, [last])

	return (
		<div className="App">
			<div className={`MainContainer ${styles.Container}`}>
				<ScrollToTop />
				{/* <Header /> */}

				<div className={styles.BackgroundImage}>
					{storyData[activeIndex]?.mediaType === "image" ? (
						<img
							src={resolveMediaUrl(storyData[activeIndex]?.mediaUrl)}
							alt="PostImage"
							className={styles.BackgroundImage}
						/>
					) : storyData[activeIndex]?.mediaType === "video" ? (
						<video
							src={resolveMediaUrl(storyData[activeIndex]?.mediaUrl)}
							className={styles.BackgroundImage}
							autoPlay
							muted
							loop
						></video>
					) : (
						""
					)}
					<div className={styles.Overlay}></div>
				</div>

				<div className={styles.ViewPost}>
					<div className={styles.Left}>
						<div className={styles.StoryIndicatorBar}>
							<button
								className={styles.BackBtn}
								onClick={(e) => {
									e.stopPropagation();
									navigate(-1);
								}}
							>
								<GoArrowLeft />
							</button>
							{storyData.map((_, index) => {
								return (
									<div className={styles.Bars} key={index} onClick={() => setActiveIndex(index)}>
										{index < activeIndex && <span className={styles.on}></span>}
										{index === activeIndex && !isClicked && (
											<span className={!isClicked ? styles.pause : ""}></span>
										)}
										{index === activeIndex && <span className={isClicked ? styles.active : ""}></span>}
										{index === activeIndex && activeIndex === storyData.length - 1 && last && (
											<span className={styles.on}></span>
										)}
									</div>
								);
							})}
						</div>

						{isMobile ? (
							<div className={styles.UserContainer}>
								<div className={styles.ULeft}>
									<div className={styles.ImageContainer}>
										<img
											src={storyUserData?.ProfilePic || DefaultProfilePic}
											onError={(e) => { e.target.src = DefaultProfilePic; }}
											alt=""
										/>
									</div>

									<div className={styles.TextWrapper}>
										<div className={styles.name}>{storyUserData?.username}</div>
										<div className={styles.UserName}>@{storyUserData?.GetstatedName || storyUserData?.username?.toLowerCase().replace(/\s/g, '') || "user"}</div>
									</div>
								</div>

								<div className={styles.URight} onClick={() => { setThreeDotShow(!threeDotShow); setIsClicked(false); }}>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="36"
										height="37"
										viewBox="0 0 36 37"
										fill="none">
										<path
											d="M18.0577 5.30469C16.4211 5.30469 15.082 6.64375 15.082 8.28038C15.082 9.91701 16.4211 11.2561 18.0577 11.2561C19.6944 11.2561 21.0334 9.91701 21.0334 8.28038C21.0334 6.64375 19.6944 5.30469 18.0577 5.30469ZM18.0577 26.1346C16.4211 26.1346 15.082 27.4736 15.082 29.1102C15.082 30.7469 16.4211 32.0859 18.0577 32.0859C19.6944 32.0859 21.0334 30.7469 21.0334 29.1102C21.0334 27.4736 19.6944 26.1346 18.0577 26.1346ZM18.0577 15.7196C16.4211 15.7196 15.082 17.0587 15.082 18.6953C15.082 20.3319 16.4211 21.671 18.0577 21.671C19.6944 21.671 21.0334 20.3319 21.0334 18.6953C21.0334 17.0587 19.6944 15.7196 18.0577 15.7196Z"
											fill="white"
										/>
									</svg>
								</div>
							</div>
						) : null}

						<div className={styles.ImageContainer}>
							{isLoading ? (
								<FallingLines color="#A6539D" width="100" visible={true} ariaLabel="falling-lines-loading" />
							) : storyData[activeIndex]?.mediaType === "image" ? (
								<img src={resolveMediaUrl(storyData[activeIndex]?.mediaUrl)} alt="" />
							) : storyData[activeIndex]?.mediaType === "video" ? (
								<video src={resolveMediaUrl(storyData[activeIndex]?.mediaUrl)} controls autoPlay></video>
							) : (
								""
							)}
						</div>

						<div className={styles.OverFlowButton}>
							<button
								onClick={() => {
									if (activeIndex > 0) setActiveIndex(activeIndex - 1);
									setIsClicked(true);
								}}></button>
							<button onClick={() => setIsClicked(!isClicked)}></button>
							<button
								onClick={() => {
									if (activeIndex < storyData.length - 1) setActiveIndex(activeIndex + 1);
									setIsClicked(true);
								}}></button>
						</div>
					</div>

					<div className={styles.Right}>
						<div className={styles.RightTopContainer}>
							<div className={styles.CommentWrapper}>
								{isMobile ? null : (
									<div className={styles.UserContainer}>
										<div className={styles.ULeft}>
											<div className={styles.ImageContainer}>
												<img
													src={storyUserData?.ProfilePic || DefaultProfilePic}
													onError={(e) => { e.target.src = DefaultProfilePic; }}
													alt=""
												/>
											</div>

											<div className={styles.TextWrapper}>
												<div className={styles.name}>{storyUserData?.username}</div>
												<div className={styles.UserName}>@{storyUserData?.GetstatedName || storyUserData?.username?.toLowerCase().replace(/\s/g, '') || "user"}</div>
											</div>
										</div>

										<div className={styles.URight} onClick={() => { setThreeDotShow(!threeDotShow); setIsClicked(false); }}>
											<svg
												xmlns="http://www.w3.org/2000/svg"
												width="36"
												height="37"
												viewBox="0 0 36 37"
												fill="none">
												<path
													d="M18.0577 5.30469C16.4211 5.30469 15.082 6.64375 15.082 8.28038C15.082 9.91701 16.4211 11.2561 18.0577 11.2561C19.6944 11.2561 21.0334 9.91701 21.0334 8.28038C21.0334 6.64375 19.6944 5.30469 18.0577 5.30469ZM18.0577 26.1346C16.4211 26.1346 15.082 27.4736 15.082 29.1102C15.082 30.7469 16.4211 32.0859 18.0577 32.0859C19.6944 32.0859 21.0334 30.7469 21.0334 29.1102C21.0334 27.4736 19.6944 26.1346 18.0577 26.1346ZM18.0577 15.7196C16.4211 15.7196 15.082 17.0587 15.082 18.6953C15.082 20.3319 16.4211 21.671 18.0577 21.671C19.6944 21.671 21.0334 20.3319 21.0334 18.6953C21.0334 17.0587 19.6944 15.7196 18.0577 15.7196Z"
													fill="white"
												/>
											</svg>
										</div>
									</div>
								)}

								<div className={styles.ActionContainer}>
									<div className={styles.Like} onClick={handelLike}>
										{isLiked ? <img src={HeartFilled} alt="" /> : <img src={HeartUnfilled} alt="" />}
										<p>{likeCount}</p>
									</div>

									<div
										className={styles.Comment}
										onClick={() => {
											setShowComments(!showComments);
										}}>
										<img src={comment} alt="" />
										<p>{commentsData?.length}</p>
									</div>

									{/* <RWebShare
										data={{
											text: "fameo-X Story",
											url: "/Story/" + storyUserData?._id,
											title: "fameo-X",
										}}
										onClick={() => console.log("shared successfully!")}> */}
									<div
										className={styles.Share}
										onClick={() =>
											dispatch(setShareData({ show: true, endPoint: "/Story/", id: storyUserData._id }))
										}>
										<img src={share} alt="" />
									</div>
									{/* </RWebShare> */}
								</div>

								{isMobile ? (
									showComments && (
										<>
											<div className={styles.CommentContainer}>
												<div className={styles.TopBar}>
													<div
														className={styles.TopLeft}
														onClick={() => {
															setShowComments(false);
														}}>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="15"
															height="15"
															viewBox="0 0 15 15"
															fill="none">
															<path
																d="M4.12236 6.40062L8.86776 1.65523L7.61683 0.404297L0.735823 7.2853L7.61683 14.1663L8.86776 12.9154L4.12236 8.16997H14.8906V6.40062H4.12236Z"
																fill="white"
															/>
														</svg>
														<p>Comments</p>
													</div>
													<div className={styles.TopRight} onClick={() => setShowSortDropdown(!showSortDropdown)} style={{ position: 'relative', cursor: 'pointer' }}>
														<p>{sortOrder === "latest" ? "Latest" : "Oldest"}</p>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="23"
															height="22"
															viewBox="0 0 23 22"
															fill="none"
															style={{ transform: showSortDropdown ? 'rotate(180deg)' : 'none', transition: '0.3s' }}>
															<path
																d="M11.5603 13.9421L7.80664 10.1884L9.05846 8.9375L11.5603 11.4402L14.0622 8.9375L15.314 10.1884L11.5603 13.9421Z"
																fill="white"
															/>
														</svg>
														{showSortDropdown && (
															<div className={styles.SortDropdown}>
																<button onClick={(e) => { e.stopPropagation(); setSortOrder("latest"); setShowSortDropdown(false); }}>Latest</button>
																<button onClick={(e) => { e.stopPropagation(); setSortOrder("oldest"); setShowSortDropdown(false); }}>Oldest</button>
															</div>
														)}
													</div>
												</div>

												<div className={styles.BottomBar}>
													{isLoading ? (
														<FallingLines
															color="#3A0DBB"
															width="50"
															visible={true}
															ariaLabel="falling-lines-loading"
														/>
													) : (
														getSortedComments()?.map((data, index) => {
															return (
																<div key={index} className={styles.CommentContainerWrapper}>
																	<CommentBox
																		data={data}
																		userId={userId}
																		commentId={commentId}
																		setCommentId={setCommentId}
																		handleLikeComment={handleLikeComment}
																	/>

																	{data.Comments?.map((d, i) => (
																		<div key={i} className={styles.SubCommentBoxWrapper}>
																			<SubCommentBox
																				data={d}
																				parentId={data._id}
																				userId={userId}
																				commentId={commentId}
																				setCommentId={setCommentId}
																				handleLikeComment={handleLikeComment}
																			/>

																			{d.Comments?.map((sd, si) => (
																				<div key={si} className={styles.ThirdLayerBoxWrapper}>
																					<ThirdLayerBox
																						data={sd}
																						storyId={data._id}
																						parentId={d._id}
																						userId={userId}
																						handleLikeComment={handleLikeComment}
																					/>
																				</div>
																			))}
																		</div>
																	))}
																</div>
															);
														})
													)}
												</div>
											</div>
											<div className={styles.InputWrapper}>
												{commentId && (
													<div className={styles.ReplyingBanner}>
														<p>Replying to <span>@{getReplyingToUsername(commentId)}</span></p>
														<button onClick={() => setCommentId("")}><RxCross2 /></button>
													</div>
												)}
												<div className={styles.InputAndSubmit}>
													<div className={styles.InputContainer}>
														<input
															type="text"
															placeholder={commentId ? "Replying to comment..." : "Type your Comment"}
															value={commentText}
															ref={inputRef}
															onClick={() => setIsClicked(false)}
															onChange={(e) => setCommentText(e.target.value)}
															onKeyDown={(e) => {
																if (e.key === "Enter") {
																	if (commentId) postCommentOnComment();
																	else postComment();
																}
															}}
														/>
														<button className={styles.EmojiBtn} onClick={() => setOpenEmoji(!openEmoji)}>
															<EmojiBtnIcon />
														</button>
													</div>

													<button
														className={styles.SubmitBtn}
														onClick={() => {
															if (commentId) postCommentOnComment();
															else postComment();
														}}>
														<svg
															xmlns="http://www.w3.org/2000/svg"
															width="44"
															height="44"
															viewBox="0 0 44 44"
															fill="none">
															<path
																d="M40.3337 22L3.66699 3.66663L11.0003 22L3.66699 40.3333L40.3337 22Z"
																fill="white"
															/>
														</svg>
													</button>
												</div>

												{openEmoji && (
													<div className={styles.EmojiContainer}>
														<EmojiPicker
															height="100%"
															width="100%"
															onEmojiClick={(e) => setCommentText((prevText) => prevText + e.emoji)}
															emojiStyle={"apple"}
														/>
													</div>
												)}
											</div>{" "}
										</>
									)
								) : (
									<>
										<div className={styles.CommentContainer}>
											<div className={styles.TopBar}>
												<div className={styles.TopLeft}>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="15"
														height="15"
														viewBox="0 0 15 15"
														fill="none">
														<path
															d="M4.12236 6.40062L8.86776 1.65523L7.61683 0.404297L0.735823 7.2853L7.61683 14.1663L8.86776 12.9154L4.12236 8.16997H14.8906V6.40062H4.12236Z"
															fill="white"
														/>
													</svg>
													<p>Comments</p>
												</div>
												<div className={styles.TopRight} onClick={() => setShowSortDropdown(!showSortDropdown)} style={{ position: 'relative', cursor: 'pointer' }}>
													<p>{sortOrder === "latest" ? "Latest" : "Oldest"}</p>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="23"
														height="22"
														viewBox="0 0 23 22"
														fill="none"
														style={{ transform: showSortDropdown ? 'rotate(180deg)' : 'none', transition: '0.3s' }}>
														<path
															d="M11.5603 13.9421L7.80664 10.1884L9.05846 8.9375L11.5603 11.4402L14.0622 8.9375L15.314 10.1884L11.5603 13.9421Z"
															fill="white"
														/>
													</svg>
													{showSortDropdown && (
														<div className={styles.SortDropdown}>
															<button onClick={(e) => { e.stopPropagation(); setSortOrder("latest"); setShowSortDropdown(false); }}>Latest</button>
															<button onClick={(e) => { e.stopPropagation(); setSortOrder("oldest"); setShowSortDropdown(false); }}>Oldest</button>
														</div>
													)}
												</div>
											</div>

											<div className={styles.BottomBar}>
												{isLoading ? (
													<FallingLines
														color="#3A0DBB"
														width="50"
														visible={true}
														ariaLabel="falling-lines-loading"
													/>
												) : (
													getSortedComments()?.map((data, index) => {
														return (
															<div key={index} className={styles.CommentContainerWrapper}>
																<CommentBox
																	data={data}
																	userId={userId}
																	commentId={commentId}
																	setCommentId={setCommentId}
																	handleLikeComment={handleLikeComment}
																/>

																{data.Comments?.map((d, i) => (
																	<div key={i} className={styles.SubCommentBoxWrapper}>
																		<SubCommentBox
																			data={d}
																			parentId={data._id}
																			userId={userId}
																			commentId={commentId}
																			setCommentId={setCommentId}
																			handleLikeComment={handleLikeComment}
																		/>

																		{d.Comments?.map((sd, si) => (
																			<div key={si} className={styles.ThirdLayerBoxWrapper}>
																				<ThirdLayerBox
																					data={sd}
																					storyId={data._id}
																					parentId={d._id}
																					userId={userId}
																					handleLikeComment={handleLikeComment}
																				/>
																			</div>
																		))}
																	</div>
																))}
															</div>
														);
													})
												)}
											</div>
										</div>
										<div className={styles.InputWrapper}>
											{commentId && (
												<div className={styles.ReplyingBanner}>
													<p>Replying to <span>@{getReplyingToUsername(commentId)}</span></p>
													<button onClick={() => setCommentId("")}><RxCross2 /></button>
												</div>
											)}
											<div className={styles.InputAndSubmit}>
												<div className={styles.InputContainer}>
													<input
														type="text"
														placeholder={commentId ? "Replying to comment..." : "Type your Comment"}
														value={commentText}
														ref={inputRef}
														onClick={() => setIsClicked(false)}
														onChange={(e) => setCommentText(e.target.value)}
														onKeyDown={(e) => {
															if (e.key === "Enter") {
																if (commentId) postCommentOnComment();
																else postComment();
															}
														}}
													/>
													<button className={styles.EmojiBtn} onClick={() => setOpenEmoji(!openEmoji)}>
														<EmojiBtnIcon />
													</button>
												</div>

												<button
													className={styles.SubmitBtn}
													onClick={() => {
														if (commentId) postCommentOnComment();
														else postComment();
													}}>
													<svg
														xmlns="http://www.w3.org/2000/svg"
														width="44"
														height="44"
														viewBox="0 0 44 44"
														fill="none">
														<path
															d="M40.3337 22L3.66699 3.66663L11.0003 22L3.66699 40.3333L40.3337 22Z"
															fill="white"
														/>
													</svg>
												</button>
											</div>

											{openEmoji && (
												<div className={styles.EmojiContainer}>
													<EmojiPicker
														height="100%"
														width="100%"
														onEmojiClick={(e) => setCommentText((prevText) => prevText + e.emoji)}
														emojiStyle={"apple"}
													/>
												</div>
											)}
										</div>{" "}
									</>
								)}
							</div>
						</div>

						{isMobile ? null : (
							<div className={styles.RightBottomContainer}>
								<button
									onClick={() => {
										if (userBtn.in > -1) {
											setUserBtn({ in: userBtn.in - 1, ml: userBtn.ml + 20 });
											setActiveUserId(allStoryUser[userBtn.in - 1]?.userId?._id);
										}
										setIsClicked(false);
									}}>
									{"<"}
								</button>

								<div className={styles.SlideImages}>
									{allStoryUser.map((data, index) => {
										return (
											<div
												key={index}
												className={`${styles.ImageWrapper} ${userBtn.in + 1 > index ? styles.inActive : ""
													}`}
												style={{
													marginLeft: index === 0 ? `${userBtn.ml}%` : "",
													zIndex: storyData.length - index,
												}}>
												{data.stories[0].mediaType === "image" && (
													<img
														src={typeof data.stories[data.stories.length - 1].mediaUrl === 'string' ? data.stories[data.stories.length - 1].mediaUrl : data.stories[data.stories.length - 1].mediaUrl?.url}
														alt=""
														onError={(e) => { e.target.src = DefaultProfilePic; }}
													/>
												)}
												{data.stories[0].mediaType === "video" && (
													<video src={typeof data.stories[data.stories.length - 1].mediaUrl === 'string' ? data.stories[data.stories.length - 1].mediaUrl : data.stories[data.stories.length - 1].mediaUrl?.url} muted />
												)}
											</div>
										);
									})}
								</div>

								<button
									onClick={() => {
										if (userBtn.in < allStoryUser.length - 1) {
											setUserBtn({ in: userBtn.in + 1, ml: userBtn.ml - 20 });
											setActiveUserId(allStoryUser[userBtn.in + 1]?.userId?._id);
										}
										setIsClicked(false);
									}}>
									{">"}
								</button>
							</div>
						)}
					</div>

					{threeDotShow && (
						<div className={styles.ThreeDotWrapper} onClick={() => setThreeDotShow(false)}>
							<div className={styles.ButtonWrapper} onClick={(e) => e.stopPropagation()}>
								{activeUserId === userId ? (
									<>
										<button onClick={() => toast.info("Story Setting coming soon")}>
											<CiSettings /> Story Setting
										</button>
										<button onClick={() => toast.info("Remove story coming soon")}>
											<RxCross2 /> Remove
										</button>
										<button onClick={() => toast.info("Edit story coming soon")}>
											<BiSolidPencil /> Edit
										</button>
									</>
								) : (
									<>
										<button onClick={() => { setShowReportModal(true); setThreeDotShow(false); }}>
											<ReportIcon /> Report
										</button>
										<button onClick={() => { setShowBlockModal(true); setThreeDotShow(false); }}>
											<BlockUserIcon /> Block User
										</button>
										<button onClick={() => toast.info("Coming soon: Remove mention")}>
											<RemoveMention /> Remove mention
										</button>
										<button onClick={() => toast.info("Coming soon: High supremacy")}>
											<BiSolidPencil /> Set to high supremacy
										</button>
										<button onClick={() => toast.info("Coming soon: Hide this story")}>
											<HidePostIcon /> Hide this post
										</button>
										<button onClick={() => handleFollow(storyUserData?._id)}>
											<UnfollowIcon /> {isFollowing ? "Unfollow" : "Follow"}
										</button>
										<button onClick={() => toast.info("Coming soon: Save story")}>
											<SaveIcon /> Save
										</button>
									</>
								)}
							</div>
						</div>
					)}

					{/* Report Modal */}
					{showReportModal && (
						<div className={styles.ModalOverlay}>
							<div className={styles.ModalContent}>
								<h2>Report User</h2>
								<p>Please tell us why you are reporting this user. Your feedback helps us keep the community safe.</p>
								<textarea
									placeholder="Enter reason for reporting..."
									value={reportReason}
									onChange={(e) => setReportReason(e.target.value)}
								/>
								<div className={styles.ModalButtons}>
									<button className={styles.CancelBtn} onClick={() => setShowReportModal(false)}>Cancel</button>
									<button className={styles.SubmitBtn} onClick={() => handleReport(storyUserData?._id)}>Submit Report</button>
								</div>
							</div>
						</div>
					)}

					{/* Block Confirmation Modal (After Report) */}
					{showBlockModal && (
						<div className={styles.ModalOverlay}>
							<div className={styles.ModalContent}>
								<h2>Block {storyUserData?.username}?</h2>
								<p>Do you also want to block this user? They won't be able to find your profile, posts, or stories on the platform.</p>
								<div className={styles.ModalButtons}>
									<button className={styles.CancelBtn} onClick={() => setShowBlockModal(false)}>Maybe Later</button>
									<button className={styles.BlockBtn} onClick={() => handleBlock(storyUserData?._id)}>Yes, Block User</button>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

export default ViewStory;
// slice(userBtn.s, userBtn.e).


